import PMCampaignRateQueries from './PMCampaignRate'

const pushMessages = {
  push_messages: {
    ...PMCampaignRateQueries,
  }
}

export default pushMessages